import React, { useState } from 'react';
import ForgotPasswordForm from 'components/forms/ForgotPasswordForm';
import { withGuestGuard } from 'components/auth/withGuestGuard';

const ForgotPasswordPage = () => {
    const [success, setSuccess] = useState(false);

    return (
        <div className="container max-w-md mx-auto pt-12 pb-24">
            <div className="text-center">
                <h1>Ponastavi svoje geslo</h1>
                {!success && (
                    <p className="mt-4 mb-8">
                        Vpiši elektronski naslov, s katerim si ustvaril KZV račun in poslali ti bomo povezavo za
                        ponastavitev gesla.
                    </p>
                )}
            </div>
            {!success && <ForgotPasswordForm onSuccess={() => setSuccess(true)} />}

            {success && (
                <div className="text-center">
                    <h3 className="mt-4">Preveri e-poštni nabiralnik</h3>
                    <p className="mt-2">
                        Na vnešeni e-poštni naslov smo poslali povezavo, preko katere lahko ponastaviš svoje geslo.{' '}
                        <span className="font-bold">Bodi potrpežljiv</span>, saj lahko pošiljanje traja tudi več minut.
                    </p>
                </div>
            )}
        </div>
    );
};

export default withGuestGuard(ForgotPasswordPage);
